export default __webpack_public_path__ + "static/media/Copy.c502ee62.svg";